<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 673.42,
      left: -204.82,
      width: 481.664,
      height: 741.853,
      rotation: 145.154,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: 434.03,
      left: -306.01,
      width: 569.031,
      height: 853.003,
      rotation: -17.229,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 263.77,
      left: -393.46,
      width: 693.598,
      height: 1039.4,
      rotation: 4.084,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: 226.49,
      left: 315.29,
      width: 666.589,
      height: 1081.794,
      rotation: 73.113,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--1', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="498"
    height="742"
    viewBox="0 0 498 742"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M378.899 252.413C323.618 435.436 583.671 729.273 466.696 740.617C349.72 751.96 38.4845 608.231 6.3563 397.763C-28.2354 171.157 94.947 12.2593 211.922 0.915635C328.897 -10.4281 429.703 84.2124 378.899 252.413Z"
      fill="url(#paint0_radial_1_2)" />
    <defs>
      <radialGradient
        id="paint0_radial_1_2"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(105.814 -545.092 1923.23 739.387 312.143 575.8)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
